const { handleResponse } = require("../../../App/app.service");
const { getCsrfHeaders } = require("../../../utils/csrfClient");
const viz_url = process.env.REACT_APP_VIZ_URL;
class ManagementService {
  authHeader() {
    return {
      "Content-Type": "application/json; charset=utf-8",
      ...getCsrfHeaders(),
    };
  }
  getQuotaFiscalQuarterFilters() {
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: null,
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/filters`,
      requestOptions
    ).then(handleResponse);
  }
  getQuotaDataV2(filters, isDryRun) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        filters,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/data?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  getTeamQuotaDataV2(filters, isDryRun) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        filters,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/team/data?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  getCompanyQuotaDataV2(filters, isDryRun) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        filters,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/company/data?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  updateQuotaDataV2(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/self-service/rep/v2?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  updateTeamQuotaData(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/self-service/team/v2?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  updateCompanyQuotaData(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/self-service/company/v2?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
  initiateQuotaRemoval(type) {
    const params = type ? `?type=${type}` : '';
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };

    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/initiate${params}`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-removal/quota-reps
  removeQuotaForReps({ team, fiscalQuarter, userId }) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({ team, fiscalQuarter, userId }),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/quota-reps`,
      requestOptions
    ).then(handleResponse);
  }

  // DELETE /self-service/quota-management/quota-removal?team=...&fiscalQuarters=...&userId=...
  deleteQuotaRemoval({ team, fiscalQuarters, userId }) {
    const params = new URLSearchParams({
      team,
      fiscalQuarters: Array.isArray(fiscalQuarters) ? fiscalQuarters.join(',') : fiscalQuarters,
      userId,
    });
    const requestOptions = {
      method: "DELETE",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal?${params.toString()}`,
      requestOptions
    ).then(handleResponse);
  }

  // GET /self-service/quota-management/quota-adding/reps
  getQuotaAddingReps() {
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/reps`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-adding/rep-info
  getQuotaAddingRepInfo({ userId }) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({ userId }),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/rep-info`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-adding/rep-info
  createQuotaInfo(createQuotaBody) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(createQuotaBody),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create`,
      requestOptions
    ).then(handleResponse);
  }

  bulkUpsertQuota(bulkQuotaData) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(bulkQuotaData),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create`,
      requestOptions
    ).then(handleResponse);
  }

  bulkUpsertTeamQuota(bulkTeamQuotaData) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(bulkTeamQuotaData),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create-team`,
      requestOptions
    ).then(handleResponse);
  }

  bulkUpsertCompanyQuota(bulkCompanyQuotaData) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(bulkCompanyQuotaData),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create-company`,
      requestOptions
    ).then(handleResponse);
  }

  // GET /self-service/quota-management/quota-adding/quarters
  getQuotaAddingQuarters(type) {
    const params = type ? `?type=${type}` : '';
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/quarters${params}`,
      requestOptions
    ).then(handleResponse);
  }
  // POST /self-service/quota-management/quota-removal/quota-teams
  getQuotaTeams({ team, fiscalQuarter }) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({ team, fiscalQuarter }),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/quota-teams`,
      requestOptions
    ).then(handleResponse);
  }

  // DELETE /self-service/quota-management/quota-removal/quota-teams?team=...&fiscalQuarters=...
  deleteQuotaTeam({ team, fiscalQuarters }) {
    const params = new URLSearchParams({
      team,
      fiscalQuarters: Array.isArray(fiscalQuarters) ? fiscalQuarters.join(',') : fiscalQuarters,
    });
    const requestOptions = {
      method: "DELETE",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/quota-teams?${params.toString()}`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-removal/quota-company
  getQuotaCompany({ fiscalQuarter }) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({ fiscalQuarter }),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/quota-company`,
      requestOptions
    ).then(handleResponse);
  }

  // DELETE /self-service/quota-management/quota-removal/quota-company?fiscalQuarter=...
  deleteQuotaCompany({ fiscalQuarter }) {
    const params = new URLSearchParams({
      fiscalQuarter,
    });
    const requestOptions = {
      method: "DELETE",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-removal/quota-company?${params.toString()}`,
      requestOptions
    ).then(handleResponse);
  }
  // GET /self-service/quota-management/quota-adding/teams
  getCurrentAndFutureTeamQuotas() {
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/teams`,
      requestOptions
    ).then(handleResponse);
  }

  // GET /self-service/quota-management/quota-adding/company
  getCurrentAndFutureCompanyQuotas() {
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/company`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-adding/create-team
  createTeamQuota(createTeamQuotaBody) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(createTeamQuotaBody),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create-team`,
      requestOptions
    ).then(handleResponse);
  }

  // POST /self-service/quota-management/quota-adding/create-company
  createCompanyQuota(createCompanyQuotaBody) {
    const requestOptions = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify(createCompanyQuotaBody),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-adding/create-company`,
      requestOptions
    ).then(handleResponse);
  }

  // GET /self-service/quota-management/quota-update/available-fiscal-quarters?type=...
  getAvailableFiscalQuarters(type) {
    const params = type ? `?type=${type}` : '';
    const requestOptions = {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
    };
    return fetch(
      `${viz_url}/api/self-service/quota-management/quota-update/available-fiscal-quarters${params}`,
      requestOptions
    ).then(handleResponse);
  }

  /**
   * Update quota with optimistic locking (checks old value matches current DB value)
   * Separate endpoint for MaintainenenceTableDataGrid updates
   * Returns both successful and failed updates with current values for conflicts
   */
  updateQuotaWithOptimisticLock(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/updateWithLock?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }

  /**
   * Update team quota with optimistic locking
   */
  updateTeamQuotaWithOptimisticLock(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/team/updateWithLock?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }

  /**
   * Update company quota with optimistic locking
   */
  updateCompanyQuotaWithOptimisticLock(updatedObjects, isDryRun) {
    const requestOptions = {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: this.authHeader(),
      body: JSON.stringify({
        updatedObjects,
      }),
    };

    return fetch(
      `${viz_url}/api/manage/v2/quotaMaintainence/company/updateWithLock?dryRun=${isDryRun}`,
      requestOptions
    ).then(handleResponse);
  }
}
const managementService = new ManagementService();
export default managementService;
